module.exports = __webpack_public_path__ + "static/media/help5.b623c9bd.png";